import { render } from "./FertilityCenter.vue?vue&type=template&id=6742a39b&scoped=true"
import script from "./FertilityCenter.vue?vue&type=script&lang=ts"
export * from "./FertilityCenter.vue?vue&type=script&lang=ts"

import "./FertilityCenter.vue?vue&type=style&index=0&id=6742a39b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6742a39b"

export default script